import { t } from 'i18next';

import { ErrorResponseErrorItemCodeAuth } from '../../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodeAuth, string> => ({
  'auth:invalid_credentials': t('auth.invalidCredentials', {
    ns: 'apiErrorCodes',
    defaultValue: 'Felaktig e-postadress eller lösenord.',
  }),
  'auth:mismatched_email': t('auth.mismatchedEmail', {
    ns: 'apiErrorCodes',
    defaultValue: 'Angiven e-postadress matchar inte det existerande kontots e-postadress.',
  }),
  'auth:user_disabled': t('auth.userDisabled', {
    ns: 'apiErrorCodes',
    defaultValue: 'Användaren är inaktiverad.',
  }),
  'auth:invalid_authentication_flow': t('auth.invalidAuthenticationFlow', {
    ns: 'apiErrorCodes',
    defaultValue: 'Ogiltig autentiseringsmetod.',
  }),
  'auth:sso_required': t('auth.ssoRequired', {
    ns: 'apiErrorCodes',
    defaultValue:
      'SSO krävs för denna domän. Du måste aktivera SSO för ditt konto innan du kan logga in.',
  }),
  'auth:password_only': t('auth.passwordOnly', {
    ns: 'apiErrorCodes',
    defaultValue: 'Endast lösenordsautentisering är tillgänglig för denna domän.',
  }),
  'auth:sso_disconnection_not_allowed': t('auth.ssoDisconnectionNotAllowed', {
    ns: 'apiErrorCodes',
    defaultValue: 'SSO-anslutning kan inte avslutas för denna domän.',
  }),
  'auth:zitadel_required': t('auth.zitadelRequired', {
    ns: 'apiErrorCodes',
    defaultValue:
      'Ditt lösenord behöver uppdateras innan du kan logga in. Gå till inloggningssidan och logga in igen så guidas du till att ange ett nytt.',
  }),
  'auth:zitadel_unavailable': t('auth.zitadelUnavailable', {
    ns: 'apiErrorCodes',
    defaultValue:
      'Inloggningen kunde inte förberedas just nu på grund av ett konfigurationsfel hos oss. Försök igen om en stund, eller kontakta vår support om problemet kvarstår.',
  }),
});
